import * as v from "@thi.ng/vectors";

import { height, render, width } from "./render";
import { nitrous } from "./structure";
import { tick } from "./simulate";

function run() {
  const canvas = document.getElementById("molecule-canvas");
  if (canvas == null) {
    console.error("No canvas for molecule!");
    return;
  }
  if (!(canvas instanceof HTMLCanvasElement)) {
    console.error("#molecule-canvas isn't a canvas!");
    return;
  }
  const context = canvas.getContext("2d");
  if (context == null) {
    console.error("Couldn't get rendering context");
    return;
  }

  let mousePosition: v.Vec2 | null = null;

  canvas!.addEventListener("mousemove", function (e: MouseEvent) {
    const relativeX = e.clientX - canvas.offsetLeft;
    const relativeY = e.clientY - canvas.offsetTop;
    if (
      relativeX > 0 &&
      relativeX < canvas.width &&
      relativeY > 0 &&
      relativeY < canvas.height
    ) {
      mousePosition = v.vec2(relativeX, relativeY);
    } else {
      mousePosition = null;
    }
  });
  canvas!.addEventListener("mouseleave", function () {
    mousePosition = null;
  });

  function runRender(lastT: number) {
    const t = performance.now();

    // Get the DPR and size of the canvas
    const dpr = window.devicePixelRatio;
    const rect = canvas!.getBoundingClientRect();

    // Set the "actual" size of the canvas
    (canvas! as unknown as { width: number }).width = rect.width * dpr;
    (canvas! as unknown as { height: number }).height = rect.height * dpr;

    // Scale the context to ensure correct drawing operations
    context!.scale(dpr, dpr);

    // Set the "drawn" size of the canvas
    canvas!.style.width = `${rect.width}px`;
    canvas!.style.height = `${rect.height}px`;
    const sf = Math.min(rect.width / width, rect.height / height);
    const scaledMousePosition =
      mousePosition == null
        ? null
        : v.asVec2(
            v.sub2([], v.divN2([], mousePosition, sf), [width / 2, height / 2]),
          );
    tick(nitrous, t, lastT, scaledMousePosition);
    render(context!, sf, nitrous);
    requestAnimationFrame(() => runRender(t));
  }
  runRender(performance.now());
}

run();
